import axios from 'axios'
import { REACT_APP_PERITADOR_API } from '../../../config'

export async function updateComment(id, comment) {
  const response = await axios.patch(
    `${REACT_APP_PERITADOR_API}/takingCarManagment/updateComment`,
    {id, comment}
  )
  return response.data
}